/**
 * External dependencies
 */
import type {
	AlternativeIndex,
	ConfettiType,
	HeatmapMode,
	HeatmapResolution,
} from '@nab/types';

/**
 * Internal dependencies
 */
import type { State } from '../config';

export function getActiveAlternative( state: State ): AlternativeIndex {
	return state.ui.activeAlternative;
}

export function getActiveFilter( state: State ): ConfettiType {
	return state.ui.activeFilter;
}

export function getActiveMode( state: State ): HeatmapMode {
	return state.ui.activeMode;
}

export function getActiveResolution( state: State ): HeatmapResolution {
	return state.ui.activeResolution;
}

export function getDisabledFilterOptions(
	state: State
): ReadonlyArray< string > {
	return state.ui.disabledFilterOptions;
}

export function getIFrames( state: State ): ReadonlyArray< AlternativeIndex > {
	return state.ui.iframes;
}

export function getIntensity( state: State ): number {
	return state.ui.intensity;
}

export function isInteractive( state: State ): boolean {
	return state.ui.isInteractive;
}

export function isSidebarVisible( state: State ): boolean {
	return state.ui.isSidebarVisible;
}

export function getOpacity( state: State ): number {
	return state.ui.opacity;
}
